import type { ComparisonType, CriteriaValue, Intersect } from './targetingValuesTypes.ts';

export const RequiredTargetingFormatTypeOption = {
  DISTRIBUTION_CHANNEL: 'distribution_channel',
  AD_PLACEMENT: 'ad_placement',
  DEVICE_TYPE: 'device_type',
} as const;

export const DeviceTypeOption = {
  DESKTOP_DEVICES: 'desktop_devices',
  MOBILE_DEVICES: 'mobile_devices',
  TV_DEVICES: 'tv_devices',
} as const;

export type RequiredTargetingFormType = {
  op: CriteriaValue;
  [RequiredTargetingFormatTypeOption.DEVICE_TYPE]: {
    op: Intersect;
    [DeviceTypeOption.DESKTOP_DEVICES]: null | string;
    [DeviceTypeOption.MOBILE_DEVICES]: null | string;
    [DeviceTypeOption.TV_DEVICES]: null | string;
  };
  [RequiredTargetingFormatTypeOption.DISTRIBUTION_CHANNEL]: {
    op: Intersect;
    val: null | string;
  };
  [RequiredTargetingFormatTypeOption.AD_PLACEMENT]: {
    op: ComparisonType;
    val: null | string;
  };
};
